// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__Lw2Jm","dragIcon":"SortableItem_dragIcon__1iCQl","disabled":"SortableItem_disabled__3fL1U"};